/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import {
  fetchData,
  postData,
  deleteData,
  putData,
} from "@jda/lui-portal-utilities";

import { createRequestObject, getAuthToken } from "../utility/commonUtility";
import {
  customerPayload,
  IEditCustomerRequest,
  ICreateCustomerRequest,
} from "../models/Customers/customer";
const { MANAGEMENT_SERVICE_URL, MSAL_AUTHORITY_METADATA } = window.env;

export const getUserInfo = async () => {
  const { userinfo_endpoint } = JSON.parse(MSAL_AUTHORITY_METADATA);
  let apiURL = `${userinfo_endpoint}`;
  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllCustomers = async (payload: customerPayload) => {
  const { pageNo, pageSize, searchString } = payload;
  let apiURL = `${MANAGEMENT_SERVICE_URL}/customers?page-number=${
    pageNo || 1
  }&page-size=${pageSize || 50}`;
  apiURL = searchString ? `${apiURL}&filter-name=${searchString}` : apiURL;
  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const createNewCustomer = async (data: ICreateCustomerRequest) => {
  const apiURL = `${MANAGEMENT_SERVICE_URL}/customers`;
  const payload = {
    name: data.name,
    jpowerId: +data.jpowerId,
    accountKey: data.accountKey,
  };
  return postData<any>(createRequestObject(apiURL), payload, getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteCustomer = async (id: string) => {
  const apiURL = `${MANAGEMENT_SERVICE_URL}/customers/${id}`;
  return deleteData(createRequestObject(apiURL), getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const updateCustomer = async (data: IEditCustomerRequest) => {
  const { name, jpowerId, id } = data;
  const apiURL = `${MANAGEMENT_SERVICE_URL}/customers/${id}`;
  return putData<any>(
    createRequestObject(apiURL),
    { name, jpowerId: +jpowerId },
    getAuthToken
  )
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};
